import {useContext} from 'react'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import useMount from '@s-ui/react-hooks/lib/useMount'
import MoleculeModal from '@s-ui/react-molecule-modal'
import MoleculeNotification, {
  moleculeNotificationAlignItems,
  moleculeNotificationBorderSizes,
  moleculeNotificationTypes,
  moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'
import {useLocation} from '@s-ui/react-router'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'
import Icon from '@adv-mt/mt-svg-icons/lib/LockOutline.js'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {useMessagingContext} from '../../useMessagingContext/index.js'
import {TransactionContentAd} from './TransactionContentAd.js'

export const BuyerPaymentSuccessTransactionModal = () => {
  const {state: routerState} = useLocation()
  const {domain, i18n} = useContext(Context)
  const {setInteractionComponent} = useMessagingContext()

  const {page} = useAnalyticsTrack()

  const config = domain.get('config')
  const pageName = config.get('page').TRANSACTION_BUYER_PAYCAR_RAPIDPAY_PURCHASE_SUCCESS_PAGE_NAME

  useMount(async () => {
    const getTrackingData = async () => {
      return domain.get('get_page_tracking_data_use_case').execute({
        page: pageName
      })
    }

    const pageTrackingData = await getTrackingData()

    page(pageTrackingData)
  })

  const {adId, sellerName = i18n.t('COMMON.THE_SELLER')} = routerState || {}

  return (
    <MoleculeModal
      isOpen
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => setInteractionComponent({component: null, show: false})}
    >
      <div className="mt-TransactionBuyerPaymentSuccessModal-modalContainer">
        <MoleculeNotification
          alignItems={moleculeNotificationAlignItems.CENTER}
          autoClose={null}
          icon={<Icon size="medium" />}
          position="relative"
          roundedCorners={moleculeNotificationBorderSizes.medium}
          show
          showCloseButton={false}
          showLeftIconMobile
          type={moleculeNotificationTypes.success}
          variation={moleculeNotificationVariations.positive}
        >
          {i18n.t('VEHICLE_TRANSACTION.BUYER_INIT_PAYMENT_SUCCESS.NOTIFICATION_TEXT')}
        </MoleculeNotification>
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  customCallBack: () => {
                    setInteractionComponent({component: null, show: false})
                  },
                  text: i18n.t('COMMON.UNDERSTOOD')
                }
              },
              children: (
                <div className="mt-TransactionBuyerPaymentSuccessModal-modalChildren">
                  <div className="mt-TransactionBuyerPaymentSuccessModal-description">
                    {htmlStringToReactElement(
                      i18n.t('VEHICLE_TRANSACTION.BUYER_INIT_PAYMENT_SUCCESS.MAIN_TEXT', {
                        sellerName
                      })
                    )}
                  </div>
                  {adId ? <TransactionContentAd adId={adId} /> : <></>}
                </div>
              ),
              title: i18n.t('VEHICLE_TRANSACTION.BUYER_INIT_PAYMENT_SUCCESS.TITLE'),
              titleMarginBottom: 'l'
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}
